module.exports = __webpack_public_path__ + "static/img/tracey_face.365dcc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tracey_face.png
// module id = S1pF
// module chunks = 1